import { render, staticRenderFns } from "./GetItemFixProductFixProductPrice.vue?vue&type=template&id=069b400a&scoped=true"
import script from "./GetItemFixProductFixProductPrice.vue?vue&type=script&lang=js"
export * from "./GetItemFixProductFixProductPrice.vue?vue&type=script&lang=js"
import style0 from "./GetItemFixProductFixProductPrice.vue?vue&type=style&index=0&id=069b400a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069b400a",
  null
  
)

export default component.exports